import React, { useRef } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useInView } from "framer-motion";
import { Graph } from "./graph";
import { KeyContainer } from "./key-container";
import { KeyLabel } from "./key-label";
import { KeyValue } from "./key-value";
import { Percentage } from "./percentage";
import { KeyFooter } from "./key-footer";

const borderSpacing = { base: 5, lg: 7, xl: 10 };
const animationDuration = 2.5;
const animationDelay = 0.5;

export function SplitsAnimation() {
  const scope = useRef<HTMLDivElement>(null);
  const isInView = useInView(scope, { amount: 0.9 });

  return (
    <Flex
      ref={scope}
      align="start"
      bgGradient="linear(145deg, green.100 -20%, mint 120%)"
      boxSize="100%"
      p={borderSpacing}
      pos="relative"
    >
      <Flex align="end" boxSize="100%" mr={10}>
        <Graph
          isInView={isInView}
          animationRoot={scope}
          animationDuration={animationDuration}
          animationDelay={animationDelay}
        />
      </Flex>

      <KeyContainer pos="absolute" top={borderSpacing} right={borderSpacing}>
        <Box>
          <KeyLabel color="grass">Holdout group</KeyLabel>
          <KeyValue
            isInView={isInView}
            animationDuration={animationDuration}
            animationDelay={animationDelay}
            valueStart={2800}
            valueEnd={5000}
          />
          <KeyFooter>
            <Text
              as="span"
              bg="base.lightBackground"
              border="1px"
              borderColor="base.border"
              borderRadius="4px"
              color="text.secondary"
              fontSize="9px"
              px={1.5}
              py="1px"
            >
              Baseline
            </Text>
          </KeyFooter>
        </Box>

        <Box>
          <KeyLabel color="electric">Treatment</KeyLabel>
          <KeyValue
            isInView={isInView}
            animationDuration={animationDuration}
            animationDelay={animationDelay}
            valueStart={3300}
            valueEnd={9000}
          />
          <KeyFooter>
            <Percentage isInView={isInView} animationDelay={animationDelay} animationDuration={animationDuration} />
          </KeyFooter>
        </Box>
      </KeyContainer>
    </Flex>
  );
}
